import { DOCUMENT } from '@angular/common';
import {Component, Inject, Renderer2} from '@angular/core';
import { Select } from '@ngxs/store';
import { TransactionsState } from '../shared/states/transactions/transactions.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
  
  @Select(TransactionsState.bulkVerifyInProgress) bulkVerifyInProgress$: Observable<boolean>;

  constructor(
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
   
  public ngOnInit() {
  }
}
